import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "../common/component/notification/notification.service";
import { ProductionActivityService } from "./production-activity.service";

@Component({
    selector: 'production-activity',
    templateUrl: './production-activity.component.html',
    styleUrls: ['./production-activity.component.scss']
})

export class ProductionActivityComponent implements OnInit {

    productionactivity: any = { productionActivityId: 0, productionActivityName: 'test', note: '' };
    productionactivities: any[];
    isLoadPanelVisible: boolean = false;

    constructor(private notificationService: NotificationService, private route: ActivatedRoute, private productionActivityService: ProductionActivityService,
        private router: Router) {

    }
    ngOnInit(): void {

        this.route.params.subscribe(params => {
            if (params['id'] != null) {
                this.productionactivity.productionActivityId = Number(params['id']);
            }

            this.getProductionActivities();
        });
    }

    getProductionActivities() {
        this.isLoadPanelVisible = true;
        this.productionActivityService.getProductionActivities().subscribe({
            next: productionactivities => {
                this.productionactivities = productionactivities;
                if (this.productionactivity.productionActivityId) {
                    this.productionactivity.note = this.productionactivities.find(x => x.productionActivityId == this.productionactivity.productionActivityId).note;
                }
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Production Activities", error);
            }
        });
    }

    onProductionActivityChange(event) {
        if (event.value) {
            this.productionactivity.note = this.productionactivities.find(x => x.productionActivityId == event.value).note;
        } else {
            this.productionactivity.note = '';
        }
    }

    handleSubmit(e) {
        this.isLoadPanelVisible = true;

        if (this.productionactivity.productionActivityId) {
            this.productionActivityService.updateProductionActivities(this.productionactivity).subscribe({
                next: productionactivities => {
                    this.productionactivities = productionactivities;
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("success", "Updated Successfully", null);
                    window.self.close(); 
                }, error: (error: any) => {
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("error", "Error while fetching Production Activities", error);
                }
            });
        } else {
            this.productionactivity.productionActivityId = 0;
            this.productionActivityService.addProductionActivities(this.productionactivity).subscribe({
                next: productionactivities => {
                    this.productionactivities = productionactivities;
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("success", "Added Successfully", null);
                    window.self.close();
                }, error: (error: any) => {
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("error", "Error while fetching Production Activities", error);
                }
            });
        }
    }
}